import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";

export  function formatar_numeros_Componentes_Quimicos(item: any) {
    return {
      ...item,
      area: formatarNumero_recebido_com_casa_decimais(item.area),
      t: formatarNumero_recebido_com_casa_decimais(item.t),
      m: formatarNumero_recebido_com_casa_decimais(item.m),
      n: formatarNumero_recebido_com_casa_decimais(item.n),
      po: formatarNumero_recebido_com_casa_decimais(item.po),
      ko: formatarNumero_recebido_com_casa_decimais(item.ko),
      mgo: formatarNumero_recebido_com_casa_decimais(item.mgo),
      cao: formatarNumero_recebido_com_casa_decimais(item.cao),
      so: formatarNumero_recebido_com_casa_decimais(item.so),
      b: formatarNumero_recebido_com_casa_decimais(item.b),
    };
  }